import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n, { changeLanguage } from "./i18n";
import Speller from "./Speller";
import Alphabet from "./Alphabet";

// Pages by path. Anything else shows the speller.
const PAGES = [
  { path: "/", label: "nav-spell", Page: Speller },
  { path: "/alfabet", label: "nav-alphabet", Page: Alphabet },
];

export default function App() {
  const [path, setPath] = useState(window.location.pathname);
  const { t } = useTranslation();

  // Follow the browser's back and forward buttons
  useEffect(() => {
    const handlePopState = () => setPath(window.location.pathname);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // Switch pages without reloading, so the chosen language is kept
  const navigate = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const to = event.currentTarget.pathname;
    window.history.pushState(null, "", to);
    setPath(to);
  };

  const current = PAGES.find((page) => page.path === path) ?? PAGES[0];

  return (
    <div className="flex flex-col min-h-screen">
      <header className="w-full bg-gray-800 p-4">
        <div className="flex flex-wrap justify-between items-center gap-2">
          <nav className="flex gap-4">
            {PAGES.map((page) => (
              <a
                key={page.path}
                href={page.path}
                onClick={navigate}
                aria-current={page === current ? "page" : undefined}
                className={
                  page === current
                    ? "font-semibold underline underline-offset-4"
                    : "text-gray-300 hover:text-white"
                }
              >
                {t(page.label)}
              </a>
            ))}
          </nav>
          <div className="flex">
            <button
              className={`mr-2 ${
                i18n.language === "sv"
                  ? "bg-slate-500 outline outline-2 outline-slate-500/50"
                  : "bg-slate-400"
              } p-2 rounded-md`}
              onClick={() => changeLanguage("sv")} // Change to Swedish
            >
              {t("swedish")}
            </button>
            <button
              className={`mr-2 ${
                i18n.language === "en"
                  ? "bg-slate-500 outline outline-2 outline-slate-500/50"
                  : "bg-slate-400"
              } p-2 rounded-md`}
              onClick={() => changeLanguage("en")} // Change to English
            >
              {t("english-nato")}
            </button>
          </div>
        </div>
      </header>
      <main className="flex-grow flex flex-col items-center px-4 py-12 md:p-24 bg-slate-800">
        <current.Page />
      </main>
      <footer className="text-center p-4 bg-gray-800 text-gray-300">
        <a
          href="https://erikmartinandersson.se"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("creator-link-description")}
        </a>
      </footer>
    </div>
  );
}
